class EnvironmentBuilder {
    private API_HOST = process.env.API_HOST
    private API_PORT = process.env.API_PORT


    private INNER_DADATA_TOKEN = process.env.DADATA_TOKEN ?
        process.env.DADATA_TOKEN
        : '202f07e5711c4f92e5167758fa392229901215ac'

    ApiURL(): string {
        if (this.API_PORT) {
            return `${this.API_HOST}:${this.API_PORT}`
        }
        return `${this.API_HOST}`
    }

    DadataToken(): string {
        return this.INNER_DADATA_TOKEN
    }
}

const env = new EnvironmentBuilder()

export const API_URL = env.ApiURL()
export const DADATA_TOKEN = env.DadataToken()
